<div class="background"></div>
<div class="content">
  <h3>{{ "accessDenied.accessDenied" | translate }}</h3>
  <p>{{ "accessDenied.sorry" | translate }}</p>
  <div class="links">
    <button mat-raised-button (click)="navigateToLaunchPad()">
      {{ "TERMS.launchpad" | translate }}
    </button>
  </div>
</div>
